import { Table } from 'antd';
import PropTypes from 'prop-types';

const BaseTable = (props) => {
  const { className, sticky = true, ...rest } = props;
  const customClassName = `base-table ${className}`;
  return (
    <Table
      {...rest}
      className={customClassName}
      scroll={{ y: `calc(100vh - 100px)` }}
      sticky={sticky}
    />
  );
};

BaseTable.defaultProps = {
  className: '',
  sticky: true,
};

BaseTable.propTypes = {
  className: PropTypes.string,
  sticky: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default BaseTable;
